var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 54,
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.49 219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #ee4036;\n      }\n\n      .cls-3 {\n        fill: #0b1838;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 346.9,
    y1: 163.04,
    x2: 346.9,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9e731"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.04,174.33h8.62v16.85h14.91v-16.85h8.59v44.67h-8.59v-19.59h-14.91v19.59h-8.62v-44.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.4,174.33h24.38v8.32h-15.94v8.08h15.94v8.17h-15.94v11.75h15.94v8.35h-24.38v-44.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.34,174.33h8.62l17.18,44.67h-8.84l-3.5-9.2h-18.23l-3.63,9.2h-8.84l17.23-44.67ZM252.71,186.17l-5.99,15.34h11.95l-5.96-15.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.72,174.33h8.5v36.56h12.39v8.11h-20.89v-44.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.68,174.33h24.69v8.38h-8.14v36.29h-8.62v-36.29h-7.93v-8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.17,174.33h8.62v16.85h14.91v-16.85h8.59v44.67h-8.59v-19.59h-14.91v19.59h-8.62v-44.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.68,102.38c-6.94,17.98-24.4,30.77-44.79,30.77-26.47,0-48.01-21.54-48.01-48.01s21.54-48.01,48.01-48.01c20.4,0,37.85,12.79,44.79,30.77h33.21c-7.9-35.79-39.87-62.64-78-62.64C35.84,5.26,0,41.09,0,85.14s35.84,79.88,79.88,79.88c38.13,0,70.1-26.85,78-62.64h-33.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.81,120.86c-5.1,10.2-15.73,16.29-28.44,16.29-14.29,0-26.63-9.64-30.73-23.46h90.27l.38-3.06c.25-2,.25-4.58.25-6.66,0-33.67-27-61.07-60.18-61.07s-60.4,27.4-60.4,61.07,27.1,60.85,60.4,60.85c26,0,47.81-15.35,58.36-41.07l1.98-4.83h-30.94l-.97,1.93ZM193.98,90.03c5.52-12.16,16.72-19.68,29.39-19.68s23.35,7.36,29.01,19.22c.06.16.12.31.19.46h-58.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "496.25 45.35 463.51 117.46 461.47 122.12 459.78 117.45 431.31 45.35 402.17 45.35 442.8 145.3 446.45 153.55 442.63 162.33 428.11 193.5 459.64 193.5 526.37 45.35 496.25 45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.56,0h29v163.04h-29V0ZM369.46,0l-37.73,163.04h29.77L399.23,0h-29.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M542.22,47.02h-4.99v-1.8h12.14v1.8h-5.01v14.59h-2.14v-14.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M565.01,54.41c-.12-2.29-.27-5.04-.24-7.08h-.07c-.56,1.92-1.24,3.96-2.07,6.23l-2.89,7.95h-1.61l-2.65-7.81c-.78-2.31-1.43-4.43-1.9-6.37h-.05c-.05,2.04-.17,4.79-.32,7.25l-.44,7.03h-2.02l1.14-16.39h2.7l2.8,7.93c.68,2.02,1.24,3.82,1.65,5.52h.07c.41-1.65,1-3.45,1.73-5.52l2.92-7.93h2.7l1.02,16.39h-2.07l-.41-7.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelly);
export default __webpack_public_path__ + "static/media/Celly.fe5a1e5d6a301662617ef83e8059761b.svg";
export { ForwardRef as ReactComponent };